import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'

import PrjsVue from "@/prj/Prjs.vue";
import PrjVue from "@/prj/Prj.vue";

import LblsVue from "@/lbl/Lbls.vue";
import LblVue from "@/lbl/Lbl.vue";

import TreesVue from "@/tree/Trees.vue";
import TreeVue from "@/tree/Tree.vue";

import IdxVue from "@/idx/IdxVue.vue"
import FinVue from "@/fin/FinVue.vue"

import WykrojnikParamsVue from "@/wykrojniki/params/WykrojnikParamsVue.vue"
import WykrojnikiVue from "@/wykrojniki/costdetail/WykrojnikiVue.vue"
import OfertaVue from "@/wykrojniki/costdetail/OfertaVue.vue"

import DevicesVue from "@/device/Devices.vue";
import DeviceVue from "@/device/Device.vue";

import ProblemVue from "@/problem/Problem.vue";
import ProblemsVue from "@/problem/Problems.vue";
import GroupsVue from "../groups/GroupsVue.vue"
import POToSendVue from "../purchase/POToSendVue.vue"
import POHistoryVue from "../purchase/POHistory.vue"

import POConfirmationVue from "../purchase/POConfirmationVue.vue"

import ReklamacjeVue from "@/reklamacja/Reklamacje.vue";
import ReklamacjaVue from "@/reklamacja/Reklamacja.vue";
import OrderVue from "@/order/OrderVue.vue"
import OrdersVue from "@/order/OrdersVue.vue"
import OperatorVue from "@/kiosk/OperatorVue.vue"
import AdminVue from "@/kiosk/AdminVue.vue"
import TransportVue from "@/transport/TransportVue.vue"
import SearcherVue from "@/searcher/Searcher.vue"
import MenuTechnologiaVue from "@/menu/MenuTechnologia/MenuTechnologiaVue.vue"
import AIVue from  "@/kiosk/AIVue.vue"
import AITestVue from  "@/kiosk/AITestVue.vue"

export class Routes {

    routes: Array<RouteConfig> = [
        {
          path: '/admin',
          name: 'Admin',
          component: AdminVue,
        },
        {
          path: '/operator',
          name: 'Operator',
          component: OperatorVue,
        },
        {
          path: '/projekty',
          name: 'Projekty',
          component: PrjsVue,
        },
        {
          name: 'Projekt',
          path: '/projekty/:prj_id',
          component: PrjVue
        },
        {
          path: '/technologie',
          name: 'Technologie',
          component: TreesVue,
        },
        {
          path: '/projekty/:prj_id/technologie',
          name: 'Technologie projektu',
          component: TreesVue,
          props: route => ({ id: route.params.prj_id})
        },
        {
          path: '/projekty/:prj_id/technologie/:id',
          name: 'Technologia projektu',
          component: TreeVue,
          props: route => ({ tree_id: route.params.id, prj_id: route.params.prj_id})
        },
        {
          name: 'Technologia',
          path: '/technologie/:id',
          component: TreeVue,
          props: route => ({ tree_id: route.params.id })
        },
        {
          name: 'Zlecenie',
          path: '/zlecenia/:id',
          component: OrderVue,
          props: route => ({ order_id: route.params.id })
        },
        {
          name: 'Zlecenia',
          path: '/zlecenia',
          component: OrdersVue,
          props: route => ({})
        },
        {
          name: 'Parametry kalkulacji',
          path: '/technologie/:id/finanse',
          component: FinVue,
          props: route => ({ tree_id: route.params.id })
        },
        {
          name: 'Wykrojniki',
          path: '/technologie/:id/wykrojniki',
          component: WykrojnikiVue,
          props: route => ({ tree_id: route.params.id })
        },
        {
          name: 'Transport',
          path: '/technologie/:id/transport',
          component: TransportVue,
          props: route => ({ tree_id: route.params.id })
        },  
        {
          name: 'Oferta',
          path: '/technologie/:id/oferta',
          component: OfertaVue,
          props: route => ({ tree_id: route.params.id })
        },
        {
          name: 'Parametry wykrojnika dla technologii',
          path: '/technologie/:id/wykrojnik-params',
          component: WykrojnikParamsVue,
          //props: route => ({ tree_id: route.params.id })
        },
        {
          path: '/etykiety',
          name: 'Etykiety',
          component: LblsVue,
        },
        {
          path: '/devices',
          name: 'Urządzenia',
          component: DevicesVue,
        },
        {
          path: '/reklamacje',
          name: 'Reklamacje',
          component: ReklamacjeVue,
        },
        {
          name: 'Urządzenie',
          path: '/devices/:device_id',
          component: DeviceVue
        },
        {
          path: '/reklamacje/:reklamacja_id',
          name: 'Reklamacja',
          component: ReklamacjaVue,
        },
        {
          name: 'Problemy urządzenia',
          path: '/devices/:device_id/problems',
          component: ProblemsVue
        },
        {
          name: 'Problemy',
          path: '/problems',
          component: ProblemsVue
        },
        {
          name: 'Problem',
          path: '/problems/:problem_id',
          component: ProblemVue
        },
        {
          path: '/projekty/:prj_id/etykiety',
          name: 'Etykiety projektu',
          component: LblsVue,
        },
        {
          path: '/projekty/:prj_id/etykiety/:lbl_id',
          name: 'Etykieta projektu',
          component: LblVue,
          props: route => ({ id: route.params.lbl_id, short:false }),
          
        },
        {
          path: '/etykiety/:lbl_id',
          name: 'Etykieta ',
          component: LblVue,
          props: route => ({ id: route.params.lbl_id, short:false })
        },
        {
          path: '/etykiety/:lbl_id/zlecenia',
          name: 'Zlecenia etykiety',
          component: OrdersVue,
          props: route => ({ id: route.params.lbl_id, short:false })
        },
        {
          path: '/etykiety/:lbl_id/indeks',
          name: 'Indeks ERP etykiety',
          component: IdxVue,
          props: route => ({ lbl_id: route.params.lbl_id})
        },
        {
          path: '/groups',
          name: 'Grupy',
          component: GroupsVue
        }, 
        {
          path: '/PoToSend',
          name: 'Zamówienia',
          component: POToSendVue
        },
        {
          path: '/POHistory/:PO_id',
          name: 'Historia Zamówienia',
          component: POHistoryVue,
          props: route => ({ PO_id: route.params.PO_id})
        },

        
        {
          path: '/PoConfirmations',
          name: 'Zamówienia potwierdzone',
          component: POConfirmationVue
        } 
        ,{
          path: '/ustawienia',
          name: 'Ustawienia',
          component: SearcherVue,
        },
        {
          path: '/AI',
          name: 'AI',
          component: AIVue
        },
   
        
      ]


  constructor() {
    for (let i=0;i<this.routes.length;i++) {
        const r=this.routes[i]
        if (!r.meta) r.meta={}
        if (!r.meta.label) r.meta.label=  r.name 
      }
    }
  
    public get_routes() {
        return this.routes
    }
}